import jwt_decode from 'jwt-decode';

export const DEFAULT_SSO_LOGIN_URL = 'https://localhost:5000/sso/login';
export const DEFAULT_SSO_LOGOUT_URL = 'https://localhost:5000/sso/logout';

function readConfigUrl(key: 'ssoLoginUrl' | 'ssoLogoutUrl'): string | undefined {
    const value = window.$config && window.$config[key];
    if (typeof value === 'string' && value.trim()) {
        return value.trim();
    }
    return undefined;
}

/** No-op; kept for callers that awaited runtime config load before redirect. */
export async function ensureSsoRuntimeConfigLoaded(): Promise<void> {
    return;
}

export function getSsoLoginUrl(): string {
    return readConfigUrl('ssoLoginUrl') || DEFAULT_SSO_LOGIN_URL;
}

export function getSsoLogoutUrl(): string {
    return readConfigUrl('ssoLogoutUrl') || DEFAULT_SSO_LOGOUT_URL;
}

/** Logout routes must run without a token (including embedded global logout iframes). */
export function isLogoutPath(pathname: string): boolean {
    const path = (pathname || '').split('?')[0].toLowerCase();
    return path === '/logout' || path.endsWith('/logout');
}

export async function redirectToSsoLogin(): Promise<void> {
    window.location.href = getSsoLoginUrl();
}

export function hasAuthToken(): boolean {
    const t = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    if (!t.trim()) {
        return false;
    }
    try {
        const decoded: any = jwt_decode(t);
        if (decoded.exp && typeof decoded.exp === 'number') {
            return decoded.exp * 1000 > Date.now();
        }
    } catch {
        return false;
    }
    return true;
}

export async function clearStoredAuthToken(): Promise<void> {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
}

export function isChangePasswordRequiredFromToken(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
        return false;
    }
    try {
        const decodedToken: any = jwt_decode(token);
        let changePasswordRequiredClaim =
            decodedToken.ChangePasswordRequired;
        if (changePasswordRequiredClaim === undefined || changePasswordRequiredClaim === null) {
            changePasswordRequiredClaim = decodedToken.changepasswordrequired;
        }
        if (changePasswordRequiredClaim === undefined || changePasswordRequiredClaim === null) {
            changePasswordRequiredClaim = decodedToken.changePasswordRequired;
        }
        return typeof changePasswordRequiredClaim === 'string'
            ? changePasswordRequiredClaim.toLowerCase() === 'true'
            : changePasswordRequiredClaim === true;
    } catch {
        return false;
    }
}

/** Use in route guards instead of next({ name: 'Login' }) when SSO owns authentication. */
export function denyUnauthorisedRoute(next: (to?: any) => void): void {
    void redirectToSsoLogin();
    next(false);
}
